var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.462 1.5H7.54a.85.85 0 00-.602.249.837.837 0 00-.243.502l-.01.232a1.96 1.96 0 01-1.962 1.803 1.93 1.93 0 01-.799-.185l-.144-.076a.864.864 0 00-1.175.326l-.485.794a.85.85 0 00.233 1.113l.195.123A1.95 1.95 0 013.409 8a1.96 1.96 0 01-.864 1.619l-.116.073a.842.842 0 00-.353 1.074l.042.08.47.808a.83.83 0 00.515.407.85.85 0 00.564-.032l.08-.04c.45-.26.984-.332 1.485-.198a1.94 1.94 0 011.183.903 1.91 1.91 0 01.256.777l.015.27a.85.85 0 00.852.76h.924c.447 0 .818-.342.852-.76l.004-.083a1.94 1.94 0 01.573-1.386 1.97 1.97 0 011.404-.57 2.02 2.02 0 01.783.184l.236.12c.37.162.8.044 1.034-.275l.054-.084.482-.8a.844.844 0 00.087-.644.84.84 0 00-.314-.462l-.204-.128a1.91 1.91 0 01-.794-1.1 1.937 1.937 0 01.198-1.478 1.95 1.95 0 01.593-.636l.12-.075c.383-.223.53-.7.354-1.077l-.053-.1-.01-.02-.437-.756a.86.86 0 00-1.002-.39l-.083.033-.077.04a1.96 1.96 0 01-1.483.207 1.95 1.95 0 01-1.194-.897 1.91 1.91 0 01-.256-.776l-.01-.192a.85.85 0 00-.242-.619.86.86 0 00-.615-.258zM8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 100 5z",
    fill: "#fff"
  })));
}

export default SvgSettings;